import { Subject } from 'rxjs';
import { produce } from 'immer';
import deepEqual from 'fast-deep-equal';
import { distinctUntilChanged, map, scan, skip, startWith } from 'rxjs/operators';
export var EmptyModelError = new Error('Model error: value is empty, you must set current value before call "getValue"');
var Model = /** @class */ (function () {
    function Model(initialValue) {
        this.destroyed = false;
        this.subject = new Subject();
        this.value = produce(initialValue, function () { }) || null;
    }
    Model.prototype.getValue = function () {
        if (!this.value) {
            throw EmptyModelError;
        }
        return this.value;
    };
    Model.prototype.update = function (updater) {
        if (this.destroyed) {
            return;
        }
        this.value = produce(this.value, function (draftValue) {
            updater(draftValue);
        });
        if (this.value) {
            this.subject.next(this.value);
        }
    };
    Model.prototype.setValue = function (value) {
        if (this.destroyed) {
            return;
        }
        this.value = produce(value, function () { });
        this.subject.next(this.value);
    };
    Model.prototype.asObservable = function () {
        var _this = this;
        return this.subject.asObservable().pipe(map(function () { return _this.getValue(); }));
    };
    Model.prototype.fieldChanges = function (key) {
        var _this = this;
        return this.asObservable().pipe(startWith(this.getValue()), map(function () { return _this.getValue()[key]; }), distinctUntilChanged(function (left, right) {
            if (left instanceof FileList) {
                return left === right;
            }
            return deepEqual(left, right);
        }), scan(function (acc, curr) {
            return {
                value: curr,
                prevValue: acc.value
            };
        }, {}), skip(1));
    };
    Model.prototype.isEmpty = function () {
        return !this.value;
    };
    Model.prototype.destroy = function () {
        this.subject.complete();
        this.value = null;
        this.destroyed = true;
    };
    Model.prototype.subscribe = function (next, error, complete) {
        return this.subject.subscribe(next, error, complete);
    };
    return Model;
}());
export { Model };
//# sourceMappingURL=Model.js.map